const isEnvDevelopment = () =>
  !process.env.GATSBY_ENV || process.env.GATSBY_ENV === 'development' || process.env.GATSBY_ENV === 'dev';

export default isEnvDevelopment;
